var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2833 7.50532L11.995 15.0053M8.005 15.0053L7.71667 7.50532M16.0233 4.83032C16.3083 4.87365 16.5917 4.91948 16.875 4.96865M16.0233 4.83032L15.1333 16.3995C15.097 16.8705 14.8842 17.3105 14.5375 17.6314C14.1908 17.9523 13.7358 18.1305 13.2633 18.1303H6.73667C6.26425 18.1305 5.80919 17.9523 5.46248 17.6314C5.11578 17.3105 4.90299 16.8705 4.86667 16.3995L3.97667 4.83032M16.0233 4.83032C15.0616 4.68491 14.0948 4.57456 13.125 4.49948M3.97667 4.83032C3.69167 4.87282 3.40833 4.91865 3.125 4.96782M3.97667 4.83032C4.93844 4.68492 5.9052 4.57457 6.875 4.49948M13.125 4.49948V3.73615C13.125 2.75282 12.3667 1.93282 11.3833 1.90198C10.4613 1.87252 9.53865 1.87252 8.61667 1.90198C7.63333 1.93282 6.875 2.75365 6.875 3.73615V4.49948M13.125 4.49948C11.0448 4.33872 8.95523 4.33872 6.875 4.49948",
    stroke: "#EB4C60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDeleteIcon);
export default __webpack_public_path__ + "static/media/redDeleteIcon.198e7164e4512871e688a49f9e39cfb0.svg";
export { ForwardRef as ReactComponent };